import Vue from 'vue'
import VueI18n from 'vue-i18n';
import i18nMessages from './i18n.messages';
import {ARTISIO_ACTIVE_LANGUAGE} from "@/modules/constants";

Vue.use(VueI18n);
Vue.config.productionTip = false;

let keys = Object.keys(i18nMessages);
let messages = {};

keys.forEach((key) => {
  messages[key] = {...i18nMessages[key]}
});

let defaultLang = 'en'
let currentLang = localStorage.getItem(ARTISIO_ACTIVE_LANGUAGE)
if (currentLang) {
  defaultLang = currentLang
}

const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: 'es',
  messages: messages
});
export default i18n;
